import { GetLockerBoxesState } from './getLockerBoxes.types'

const getLockerBoxesInitialState: GetLockerBoxesState = {
  loading: false,
  error: null,
  success: null
}

export default getLockerBoxesInitialState
